module.exports = __webpack_public_path__ + "img/ticket-fill.418ff506.svg";